/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { PhoneOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
// import { IoChatbubbles } from "react-icons/io5";
// import { MeetingType, useMeetingState } from "../../context/meeting-provider";
import { useNavigate } from "react-router-dom";
import DataProvider from "../../services";

export default function JoinMeetingButton(props: any) {
  const { appt, status } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();

  async function joinMeeting() {
    const hide = messageApi.open({
      type: "loading",
      content: "Joining meeting...",
      duration: 0,
    });
    try {
      const { data } = await DataProvider.getDailyMeeting(appt.id);
      if (data?.url) {
        window.location.replace(data.url);
      } else {
        hide();
        messageApi.open({
          type: "error",
          content: "Couldn't get a meeting link. Please try again.",
        });
      }
    } catch (error) {
      hide();
      messageApi.open({
        type: "error",
        content:
          "Couldn't join the meeting. Please check your connection and try again.",
      });
    }
  }

  async function onJoinVideoMeeting() {
    await joinMeeting();
  }

  async function onJoinVoiceMeeting() {
    await joinMeeting();
  }

  return (
    <div className="flex">
      {appt.appointmentType === "video" && (
        <Button
          disabled={status}
          onClick={onJoinVideoMeeting}
          type="primary"
          size="middle"
          style={{ backgroundColor: status ? "" : "#06509E" }}
          className="bg-[#06509E] flex items-center mb-2 mx-2 sm:w-auto w-full justify-center font-semibold"
        >
          <VideoCameraOutlined />
          Join Video Meeting
        </Button>
      )}

      {appt.appointmentType === "voice" && (
        <Button
          disabled={status}
          onClick={onJoinVoiceMeeting}
          type="primary"
          size="middle"
          style={{ backgroundColor: status ? "" : "#06509E" }}
          className="text-white flex items-center mb-2 mx-2 sm:w-auto w-full justify-center font-semibold"
        >
          <PhoneOutlined />
          Join Voice Meeting
        </Button>
      )}
      {contextHolder}
    </div>
  );
}
